import React, { useState, useEffect } from 'react';
import DocumentList from '../components/DocumentList';
import DropzoneArea from '../components/DropzoneArea';
import { Toast } from '../components/ToastProgress';
import { WebSocketProvider } from '../contexts/WebSocketProvider';
import useListContainer from '../api/listContainer';
import ContainerSelector from '../components/ContainerSelector';
import '../styles/Upload.css';


function Upload() {
    const [toasts, setToasts] = useState([]);
    const [containers, setContainers] = useState([]);

    
    const listContainer = useListContainer();
    
    const removeToast = (id) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
    };

    const [selectedContainer, setSelectedContainer] = useState(null);

    useEffect(() => {
        async function fetchData() {
            try {
                const data = await listContainer();
                setContainers(data.blobs);
            } catch (error) {

                console.error("Error retrieving information:", error);
            }
        };
        fetchData();
    
    }, [listContainer]);


    return (
        <>
            <div className='upload-container'>
                <ContainerSelector containers={containers} onSelect={setSelectedContainer} />
                <DropzoneArea setToasts={setToasts} container_name={selectedContainer} />
                
                <WebSocketProvider container_name={selectedContainer}>
                    <DocumentList setToasts={setToasts} container_name={selectedContainer}/>
                </WebSocketProvider>
                <div className="toast-container">
                {toasts.map((toast) => (
                    <Toast
                    key={toast.id}
                    id={toast.id}
                    label={toast.label}
                    progress={toast.progress}
                    onClose={removeToast}
                    />
                ))}
                </div>
            </div>
        </>
    );
}

export default Upload;